import { useState } from "react";
import { EditRowActions, Input, Td, Text, Tr } from "@/components/ui";
import type { EditarItemCatalogoInput } from "../services/catalogos-contables-admin-service";

/**
 * Fila genérica para CeCo y Cuenta · ambos comparten la forma del row
 * (código inmutable a la izquierda, nombre editable).
 * El padre conecta la mutation real vía `onGuardar` / `isPending`.
 */
export interface ItemCatalogoMinimal {
  id: string;
  codigo: string;
  nombre: string;
}

export function ItemCatalogoRow({
  item,
  onGuardar,
  isPending,
}: {
  item: ItemCatalogoMinimal;
  onGuardar: (args: { id: string; input: EditarItemCatalogoInput }) => void;
  isPending: boolean;
}) {
  const [editando, setEditando] = useState(false);
  const [nombre, setNombre] = useState(item.nombre);

  const cancelar = () => {
    setNombre(item.nombre);
    setEditando(false);
  };

  if (editando) {
    return (
      <Tr className="bg-muted/50">
        <Td>
          <Text size="xs" ff="mono">
            {item.codigo}
          </Text>
        </Td>
        <Td>
          <Input size="xs" value={nombre} onChange={(e) => setNombre(e.currentTarget.value)} autoFocus />
        </Td>
        <Td align="right">
          <EditRowActions mode="edit" saving={isPending} onCancel={cancelar} onSave={() => onGuardar({ id: item.id, input: { nombre: nombre.trim() } })} />
        </Td>
      </Tr>
    );
  }

  return (
    <Tr>
      <Td>
        <Text size="xs" ff="mono">
          {item.codigo}
        </Text>
      </Td>
      <Td>
        <Text size="sm">{item.nombre}</Text>
      </Td>
      <Td align="right">
        <EditRowActions mode="view" onEdit={() => setEditando(true)} />
      </Td>
    </Tr>
  );
}
